import { render, staticRenderFns } from "./ZnSelectCurriculumUnit.vue?vue&type=template&id=89a83150&scoped=true&lang=pug&"
import script from "./ZnSelectCurriculumUnit.vue?vue&type=script&lang=ts&"
export * from "./ZnSelectCurriculumUnit.vue?vue&type=script&lang=ts&"
import style0 from "./ZnSelectCurriculumUnit.vue?vue&type=style&index=0&id=89a83150&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a83150",
  null
  
)

export default component.exports